import Discord from "./Discord"
import Email from "./Email"
import Facebook from "./Facebook"
import Github from "./Github"
import Instagram from "./Instagram"
import Linkedin from "./Linkedin"
import Medium from "./Medium"
import Pinterest from "./Pinterest"
import Tiktok from "./Tiktok"
import Twitch from "./Twitch"
import Twitter from "./Twitter"
import Tumblr from "./Tumblr"
import Vimeo from "./Vimeo"
import Website from "./Website"
import Youtube from "./Youtube"

export default {
  Discord,
  Email,
  Facebook,
  Github,
  Instagram,
  Linkedin,
  Medium,
  Pinterest,
  Tiktok,
  Twitch,
  Twitter,
  Tumblr,
  Vimeo,
  Website,
  Youtube,
}
